import { Component, Input } from '@angular/core';

@Component({
  selector: 'digires-project-type-image',
  templateUrl: './project-type-image.component.html',
  styleUrls: ['./project-type-image.component.scss']
})
export class ProjectTypeImageComponent {
  @Input() imageURL: string;
  @Input() imageWidth: string = '30px';
  @Input() imageHidden: boolean = false;
}
